import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import DisclaimerPage from './pages/DisclaimerPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminNewsletterPage from './pages/AdminNewsletterPage';
import AdminBrandInquiriesPage from './pages/AdminBrandInquiriesPage';
import AdminContactMessagesPage from './pages/AdminContactMessagesPage';
import AboutPage from './pages/AboutPage';
import BrandsLibraryPage from './pages/BrandsLibraryPage';
import BrandSpotlightPage from './pages/BrandSpotlightPage';
import ForBrandsPage from './pages/ForBrandsPage';
import ContactPage from './pages/ContactPage';
import ActionAlertsPage from './pages/ActionAlertsPage';
import AdminActionAlertsPage from './pages/AdminActionAlertsPage';
import ShopRedirectPage from './pages/ShopRedirectPage';
import AdminBrandLinksPage from './pages/AdminBrandLinksPage';
import LookPage from './pages/LookPage';
import InstagramHubPage from './pages/InstagramHubPage';
import AdminLooksPage from './pages/AdminLooksPage';
import BlogPostPage from './pages/BlogPostPage';
import BlogHubPage from './pages/BlogHubPage';
import AdminBlogPage from './pages/AdminBlogPage';
import CookieConsent from './components/CookieConsent';
import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import useMetaPixel from './hooks/useMetaPixel';
import './App.css';

function AppContent() {
  // Google Analytics tracking
  useGoogleAnalytics();
  // Meta (Facebook) Pixel — SPA page-view tracking
  useMetaPixel();

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Navigation />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/acties" element={<ActionAlertsPage />} />
          <Route path="/action-alerts" element={<ActionAlertsPage />} />
          <Route path="/for-brands" element={<ForBrandsPage />} />
          <Route path="/voor-merken" element={<ForBrandsPage />} />
          <Route path="/ontdek-merken" element={<BrandsLibraryPage />} />
          <Route path="/merken/:slug" element={<BrandSpotlightPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/beheer/inschrijvingen" element={<AdminNewsletterPage />} />
          <Route path="/beheer/merken" element={<AdminBrandInquiriesPage />} />
          <Route path="/beheer/berichten" element={<AdminContactMessagesPage />} />
          <Route path="/beheer/acties" element={<AdminActionAlertsPage />} />
          <Route path="/beheer/links" element={<AdminBrandLinksPage />} />
          <Route path="/beheer/looks" element={<AdminLooksPage />} />
          <Route path="/beheer/inspiratie" element={<AdminBlogPage />} />
          <Route path="/instagram" element={<InstagramHubPage />} />
          <Route path="/inspiratie" element={<BlogHubPage />} />
          <Route path="/inspiratie/:slug" element={<BlogPostPage />} />
          <Route path="/look/:slug" element={<LookPage />} />
          <Route path="/shop/:slug" element={<ShopRedirectPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;